import React from 'react';
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { routers } from './routers';
import Layouts from './layouts';

function App() {
  return (
      <HashRouter>
        <Routes>
          <Route path="/" element={<Layouts />}>
            {
              routers.map((routes, index) => {
                return (
                    <Route key={index} {...routes} />
                );
              })
            }
            <Route
                path="*"
                element={<Navigate to="/" />}
            />
          </Route>
        </Routes>
      </HashRouter>
  );
}

export default App;
